import DatabaseModel from './DatabaseModel.js';

var Empresa = Object.create(DatabaseModel);

Empresa.model = 'empresa';
Empresa.modelFront = 'empresas';

export default Empresa;